<template>
  <div id="page-title" class="md:container">
    <div class="w-full">
      <h1
        class="my-3.5 break-words text-3xl lg:mb-1 lg:mt-0 lg:text-3xl lg:font-bold"
      >
        {{ productName }}
      </h1>
      <div
        v-if="desktopReviews && mobileReviews"
        ref="reviewsContainer"
        class="my-2"
        @click="toReviews"
        v-html="isMobile ? desktopReviews : mobileReviews"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ComputedRef, onBeforeUnmount, onMounted } from 'vue';

defineProps({
  isMobile: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const productName: ComputedRef<string> = computed(() => window.product.name);
const desktopReviews = computed(() => window.desktop_reviews);
const mobileReviews = computed(() => window.mobile_reviews);

const toReviews = () => {
  const reviewsContainer = document.getElementById('lipscore-review-list');

  if (reviewsContainer) {
    reviewsContainer.scrollIntoView({
      behavior: 'smooth',
    });
  }
};

let observer: MutationObserver | null = null;

const waitForNameContainers = () => {
  const nameContainers = document.querySelectorAll('.lipscore-review-author');
  nameContainers.forEach(container => {
    const element = container as HTMLElement;
    if (element.textContent?.includes('Anonymous')) {
      element.style.display = 'none';
    }
  });
};

onMounted(() => {
  // Check initially
  waitForNameContainers();

  // Set up a MutationObserver to keep watching the DOM
  observer = new MutationObserver(() => {
    waitForNameContainers();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

onBeforeUnmount(() => {
  // Clean up the observer when the component is unmounted
  if (observer) {
    observer.disconnect();
    observer = null;
  }
});
</script>

<!-- Styling the Lipscore stuff here because the magento widget settings in the admin is not being used anymore -->
<style>
#page-title,
.product-section {
  .lipscore-rating-review-link,
  #js-lipscore-reviews-tab {
    display: none;
  }

  .lipscore-rating-slider-stars-wrapper {
    cursor: pointer;

    .lipscore-svg-rating-star {
      width: 22px;
      height: 22px;
    }
  }

  .lipscore-svg-rating-star:not(.lipscore-rating-star-inactive) {
    fill: #ffdc0f;
  }

  .lipscore-rating-star-wrapper {
    pointer-events: none;
  }

  #lipscore-review-list {
    scroll-margin-top: 200px;
  }

  .lipscore-compact-rating-votes {
    color: #000;
    font-size: 18px;
    cursor: pointer;
  }

  .lipscore-compact-rating-wrapper {
    cursor: pointer;
  }

  .lipscore-review-summary-content {
    justify-content: start;
  }

  @media (min-width: 992px) {
    .lipscore-review-summary-badge-votes {
      margin-bottom: 45px;
    }
  }
}
</style>
